import React from 'react'
import VerificationSteps from '../booking/verificationsteps';
import Topbar from '../../../components/topbar/topbar';
import Footer from '../../client/appointment/footer';
import './onboarding.css';

export default function Onboarding() {
    return (
        <>
            <Topbar />

            <div className="practice-booking-step-container onboarding-process-page py-4 py-lg-5">
                <div className="container-fluid px-3 px-lg-4">
                    <VerificationSteps />
                </div>
            </div>

            <div className="onboarding-footer-wrap text-center pt-4 pt-lg-5 pb-5 padding-botton-120px">
                <div className="container-fluid px-3 px-lg-4">
                    <Footer />
                </div>
            </div>
        </>
    );
}
